import { useTranslation } from 'react-i18next';

import { Avatar } from '@/shared/components/avatar';
import type { SearchResult, SearchResultHighlights } from '@/shared/registry/types';

/**
 * A group chat in the global search results (the content of the search page's link row): avatar tile, title, member
 * count and the matching member names.
 */
export function ChatSearchResult({
  result,
  highlights,
}: {
  result: SearchResult;
  highlights?: SearchResultHighlights;
}) {
  const { t } = useTranslation('messenger');
  const members = Number(result.meta?.memberCount ?? '0');
  return (
    <>
      <Avatar name={result.title} seed={result.entityId} size="md" shape="rounded" />
      <span className="min-w-0 flex-1" data-testid="chat-search-result">
        <span className="block truncate text-[0.9375rem] font-medium text-foreground">
          {highlights?.title ?? result.title}
        </span>
        <span className="block truncate text-sm text-muted-foreground">
          {members > 0 ? t('chat.members', { count: members }) : t('search.groupChat')}
          {result.snippet && (
            <>
              {' · '}
              {highlights?.snippet ?? result.snippet}
            </>
          )}
        </span>
      </span>
    </>
  );
}
